import React, { useEffect, useState } from "react";
import Switch from "@material-ui/core/Switch";
import Popover from "@material-ui/core/Popover";
import DownloadIcon from "_shared/images/icons/download-primary.svg";
import { getBlobDownloadEndpoint } from "./ResourcesAPI/Resources.api";

const AdminModal = ({
  resources,
  openAdminModal,
  setOpenAdminModal,
  user,
  adminToggleIconRef,
  adminMode,
  setAdminMode,
  isAdminDepartment,
}) => {
  const [toggleOn, setToggleOn] = useState(false);
  const [resourcesGuideLink, setResourcesGuideLink] = useState("");

  useEffect(() => {
    setToggleOn(adminMode);
  }, [adminMode]);

  useEffect(() => {
    const fetchResourcesGuide = async () => {
      try {
        const downloadLink = await getBlobDownloadEndpoint({
          departmentId: "helpguides",
          fileName: "myApplied Resources Page Admin Tool Guide.pdf",
        });
        setResourcesGuideLink(downloadLink);
      } catch (error) {
        console.error("Failed to fetch resources guide:", error);
      }
    };

    fetchResourcesGuide();
  }, []);

  return (
    <Popover
      open={openAdminModal}
      anchorEl={adminToggleIconRef.current}
      onClose={() => setOpenAdminModal(false)}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      PaperProps={{
        className: "bg-[#FBFBFB] mt-2  ",
      }}
    >
      <div className="flex items-center justify-center rounded-lg bg-white [box-shadow:0px_4px_4px_0px_#00000040]">
        <div className="">
          <div className="flex items-center p-4">
            <div className="flex h-[39px] w-[39px] flex-shrink-0 items-center justify-center rounded-full bg-primary text-white">
              {`${user.firstName[0]}${user.lastName[0]}`}
            </div>
            <div className="pl-4">
              <p className="pb-1 text-typography-100">{`${user.firstName} ${user.lastName}`}</p>
              <p className="text-[11px] text-typography-70">
                {user.email.toLowerCase()}
              </p>
            </div>
          </div>

          {isAdminDepartment && (
            <>
              <div className="flex flex-col p-4 pt-0 [&_p]:text-[14px] [&_p]:text-typography-100">
                <div className="flex items-center justify-between">
                  <p>Admin Mode</p>
                  <Switch
                    checked={adminMode}
                    size="small"
                    onChange={() => {
                      setAdminMode(!adminMode);
                    }}
                    edge="end"
                    color="primary"
                  />
                </div>
                {/* feature not yet available */}
                {/* <div className="flex justify-between pt-[10px]">
                    <p>View As</p>
                    <img className="h-[14px] w-[14px]" src={ChevronRight} />
                  </div> */}
              </div>

              <div className="w-full border-x-0 border-b-0 border-t-[1px] border-solid border-[#EFF0F1]"></div>

              {/* Help guides listed here */}
              <div className="flex flex-col gap-y-3 p-4 [&_p]:text-[14px] [&_p]:text-typography-100">
                <div className="flex items-center gap-x-2">
                  <img className="size-[18px]" src={DownloadIcon} />
                  <a
                    href={resourcesGuideLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center  font-default text-[14px] font-semibold leading-[22px] tracking-[0.2px] text-primary"
                  >
                    {`Resources Admin Guide`}
                  </a>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </Popover>
  );
};

export default AdminModal;
